import { YesOrNoComponent } from './../../../dialog/yes-or-no/yes-or-no.component';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from './../../../components/components.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CashierRoutingModule } from './cashier-routing.module';
import { CashierManagementComponent } from './components/cashier-management/cashier-management.component';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatSelectModule } from '@angular/material/select';
import { CashierManagementDepositComponent } from './components/cashier-management-deposit/cashier-management-deposit.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaskModule } from 'ngx-mask';
import { NgxCurrencyModule } from 'ngx-currency';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { MyMissingTranslationHandler } from 'src/app/core/_config/missingTranslationHandler';
import { CashierManagementTransferBatchComponent } from './components/cashier-management-transfer-batch/cashier-management-transfer-batch.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

let materialModules = [
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSelectModule,
    MatDialogModule,
    MatAutocompleteModule,
];

@NgModule({
    declarations: [
        CashierManagementComponent,
        CashierManagementDepositComponent,
        YesOrNoComponent,
        CashierManagementTransferBatchComponent,
    ],
    imports: [
        materialModules,
        CommonModule,
        CashierRoutingModule,
        ComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxMaskModule.forRoot(),
        NgxCurrencyModule,
        TranslateModule.forChild({
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
            useDefaultLang: false,
        }),
    ],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { floatLabel: 'always' },
        },
    ],
    entryComponents: [CashierManagementDepositComponent, YesOrNoComponent],
})
export class CashierModule {}
